var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_32",
    "data-name": "Component 32",
    transform: "translate(0.14 0.14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1829",
    "data-name": "Rectangle 1829",
    width: 20,
    height: 20,
    transform: "translate(-0.14 -0.14)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2545",
    "data-name": "Group 2545",
    transform: "translate(3.147 4.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1315",
    "data-name": "Path 1315",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M5.662,0A5.625,5.625,0,1,1,0,5.624,5.644,5.644,0,0,1,5.662,0Z",
    transform: "translate(0 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M5.663,1.187a4.438,4.438,0,1,0,4.468,4.438A4.458,4.458,0,0,0,5.663,1.187M5.663,0A5.625,5.625,0,1,1,0,5.625,5.644,5.644,0,0,1,5.663,0Z",
    transform: "translate(0 0)",
    fill: "#303030"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M-1895.42-1888l3.006,3.036",
    transform: "translate(1905.148 1897)",
    fill: "none",
    stroke: "#303030",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.884962d83b300b654f1f21292c07dfa7.svg";
export { ForwardRef as ReactComponent };